import {Component} from '@angular/core';
import {UiOrganismFooterComponent} from '@shared/components/organisms/ui-organism-footer/ui-organism-footer.component';
import {UiOrganismHeaderComponent} from '@shared/components/organisms/ui-organism-header/ui-organism-header.component';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-main-layout',
  imports: [
    UiOrganismFooterComponent,
    UiOrganismHeaderComponent,
    RouterOutlet
  ], templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout {
}
